import React, { useState, useEffect } from 'react';
import * as C from "../componentsM/index";
import AwesomeSlider from 'react-awesome-slider';
import 'react-awesome-slider/dist/styles.css';
import { fetchPicturesByEvent } from '../components/apifa';
const PreSchool = () => {
  const [pictures, setPictures] = useState([]);
  const selectedEvent = "PYP activity";

  useEffect(() => {
    const loadPictures = async () => {
      const eventPictures = await fetchPicturesByEvent(selectedEvent, 1); // Fetch pictures
      console.log(eventPictures.results);
      setPictures(eventPictures.results.map((pic) => pic.image_url)); // Extract image URLs
    };

    loadPictures();
  }, [selectedEvent]);

  return (
    <>
      <C.Hero title={"PRE-SCHOOL"} image={"/hero/10.jpg"} />

      <section className="p-4 md:p-24">
        <div className="flex items-center justify-center mb-8 w-full h-[270px]">
         
        <AwesomeSlider
  className="w-full h-full"
  bullets={true} // Enable bullets for better navigation
  infinite={true}
  organicArrows={true}
  startup={true}
  play={true} // Enable autoplay
  interval={2000} // Set the interval to 2000 ms (2 seconds)
  style={{
    borderRadius: "12px", // Add rounded corners for a polished look
    overflow: "hidden", // Ensure images do not spill outside the slider
    boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)", // Add a subtle shadow
  }}
>
  {pictures
    .reduce((chunks, src, index) => {
      const chunkIndex = Math.floor(index / 3);
      if (!chunks[chunkIndex]) chunks[chunkIndex] = [];
      chunks[chunkIndex].push(src);
      return chunks;
    }, [])
    .map((chunk, chunkIndex) => (
      <div
        key={chunkIndex}
        className="flex gap-4 justify-center items-center w-full h-full"
      >
        {chunk.map((src, imageIndex) => (
          <figure
            key={imageIndex}
            className="flex justify-center items-center w-[250px] h-[250px] bg-gray-100 p-4 rounded-lg"
            style={{
              boxShadow: "0px 2px 6px rgba(0, 0, 0, 0.1)", // Add a shadow effect to images
              overflow: "hidden", // Crop overflowing parts
            }}
          >
            <img
              className="w-full h-full object-cover"
              src={src}
              alt={`Slide ${imageIndex}`}
              style={{
                borderRadius: "8px", // Add a border radius for images
                transition: "transform 0.3s ease", // Add hover effect
              }}
              onMouseOver={(e) => (e.target.style.transform = "scale(1.05)")}
              onMouseOut={(e) => (e.target.style.transform = "scale(1)")}
            />
          </figure>
        ))}
      </div>
    ))}
</AwesomeSlider>


        </div>

        <div className='flex flex-col gap-6 my-6'>

<h1 className=''>The foundation stage is based on the British National Curriculum and the philosophies of the IB Primary Years Programme. It is designed to make the child comfortable with the new environment, to develop skills, train character and enhance knowledge whilst promoting international awareness and understanding.</h1>


<h1>Our early years learning environment has been designed to enable young minds to further develop what they already know and can do. It includes teachers who understand that children develop rapidly during the early years physically, intellectually, emotionally and socially. They are responsible for ensuring that all children feel included, secure and valued and no child should be excluded or disadvantaged because of ethnicity, culture or religion, home language, family background, special educational needs, disability, gender or ability. They plan purposeful activity that provides opportunities for teaching and learning, both indoors and outdoors and provide opportunities for students to engage in their own planned activities and initiatives.</h1>


<h1>We have the following age groups in our Pre-school:</h1>
</div>


<div className="flex flex-col gap-6">


<h1 className='font-bold text-myBlue text-xl md:text-3xl'>Nursery (3 – 4 years)</h1>

<p>It is acknowledged that experiences during the early years lay the foundation for all future learning. Research indicates that the rapid rate of development that occurs in the physical, social, emotional, intellectual and aesthetic domains is  particularly significant. It is our responsibility to recognise and maximise this crucial stage of learning. Although development usually occurs in recognisable and predictable direction, it is unique in each child. For many children, these early years also mark the first transition from home to group experiences outside of the family and to new physical environments. Children at this time are ready to learn basic skills such as communication, independence and social interaction. In both groups play and independency are encouraged through hands-on activities, and introduction to basic recognition skills. A lot of focus is on EPL exercises which build their fine and gross motor skills. Children from birth are full of curiosity, and we provide a framework that gives crucial support for them to be active enquirers and lifelong learners.</p>


</div>

<div className="flex flex-col gap-6 my-6">

<h1 className='font-bold text-myBlue text-xl md:text-3xl'>Prep I (4 – 5 years) & Prep II (5 – 6 years)</h1>


<p>Children by this time are ready to learn basic skills such as recognition, basic writing, and sentence formation and articulation. We support the student’s understanding of the world and to function comfortably within it, to move from not knowing to knowing, to identifying what is real and what is not real, to acknowledge what is appropriate and what is not appropriate. Students are encouraged to be curious, be inquisitive, ask questions, explore and interact with the environment physically, socially and intellectually. Activities are geared towards using a child’s natural love for play and creativity to teach and reinforce these concepts. The structure of the learning environments, including the home, the classroom, the school and the community along with the behaviour modelled by others in that environment, particularly by the parent and the teacher, will lay down the knowledge foundation that will nurture meaningful participation and enquiry on the part of the students. Project work is both individual as well as group work, and is centred on the transdisciplinary themes. We believe our environment is one in which learning knows no bounds.

</p>

<p className='font-semibold'>* For children younger than 3 years please contact the Primary Coordinator</p>

</div>


      </section>
    </>
  );
};

export default PreSchool;
